module.exports = __webpack_public_path__ + "static/img/12.8a84b3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/eng/12.png
// module id = hwb/
// module chunks = 0